// extracted by mini-css-extract-plugin
export default {"container":"map-container_container__dluF8"};